import { render, staticRenderFns } from "./DailyExpenseView.vue?vue&type=template&id=5dab84a8&scoped=true&"
import script from "./DailyExpenseView.vue?vue&type=script&lang=js&"
export * from "./DailyExpenseView.vue?vue&type=script&lang=js&"
import style0 from "./DailyExpenseView.vue?vue&type=style&index=0&id=5dab84a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dab84a8",
  null
  
)

export default component.exports